import { OrderDataSummary } from '@zonofi/zono-money-store';
import { Divider } from '../../../components';
import './discount-modal.scss';
import { getFormattedAmount } from '@zonofi/common/functions/format-amount';

interface OrderLedgerSummaryProps {
  orderSummary?: OrderDataSummary;
  showDivider?: boolean;
  needHeading?: boolean;
}

function OrderLedgerSummary({
  orderSummary,
  showDivider = true,
  needHeading = true,
}: OrderLedgerSummaryProps) {
  if (!orderSummary) return null;

  const orderSummaryInfo = [
    {
      id: 0,
      title: 'Order Amount',
      value: getFormattedAmount(orderSummary?.total),
    },
    {
      id: 1,
      title: 'Scheme Savings',
      value: `- ${getFormattedAmount(orderSummary?.discount)}`,
      color: 'scheme-color',
    },
    {
      id: 2,
      title: 'Gross Amount',
      value: getFormattedAmount(
        Number(orderSummary.total) - Number(orderSummary.discount)
      ),
    },
    {
      id: 3,
      title: 'Tax',
      value: `+ ${getFormattedAmount(orderSummary?.tax)}`,
      color: 'tax-color',
    },
    {
      id: 3,
      title: 'Shipping Charges',
      value: `${getFormattedAmount(orderSummary?.shippingLines?.[0]?.price)}`,
    },
    {
      id: 3,
      title: 'Tax on shipping',
      value: `${getFormattedAmount(orderSummary?.shippingLines?.[0]?.priceWithTax - orderSummary?.shippingLines?.[0]?.price)}`,
    },
    {
      id: 4,
      title: 'Net Order Value',
      value: getFormattedAmount(orderSummary?.totalWithTax),
    },
  ];

  return (
    <div className="order-summary-card">
      {needHeading && (
        <div className="order-summary-card--title font-medium">
          {'ORDER SUMMARY'}
        </div>
      )}

      <div className="order-summary-card--summary-item">
        {orderSummaryInfo.map((item, index) => {
          return (
            <div key={index}>
              <div className="order-summary-card--summary-title font-regular">
                {item?.title}
              </div>
              <div
                className={`order-summary-card--summary-value font-medium ${item.color}`}
              >
                {item?.value}
              </div>
            </div>
          );
        })}
      </div>
      {showDivider && <Divider className="discount-modal__divider" />}
    </div>
  );
}

export { OrderLedgerSummary };
